import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';

export const HopBox = styled(Box)`
  display: flex;
  position: relative;

  ${({ expanded, isLast }) =>
    expanded
      ? `
      flex-direction: column;
      width: 100%;
      margin-bottom: ${isLast ? '0' : '40px'};
    `
      : `
      margin-bottom: 0;
      flex-direction: row;
      width: auto;
    `}
`;

export const StepStack = styled(Stack)`
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 16px;
`;

export const HopAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  z-index: 1;
  color: ${({ theme }) => theme.palette.fixed.white};
  font-weight: bold;
  background-color: ${({ color }) => color};
`;

export const Line = styled(Box)`
  ${({ theme, expanded }) =>
    expanded
      ? `
        position: absolute;
        left: 19px;
        top: 40px;
        bottom: -80px;
        width: 2px;
        background-color: ${theme.palette.grey['05']};
        z-index: 0;
      `
      : `
        border-bottom: 2px solid ${theme.palette.grey['05']};
        min-width: 40px;
        flex-grow: 1;
        height: 0px;
        align-self: center;
      `}
`;

export const Row = styled(Grid)`
  display: flex;
  align-items: center;
  gap: inherit;
`;
